import { render, staticRenderFns } from "./TransactionSettings.vue?vue&type=template&id=85f9e810&scoped=true"
import script from "./TransactionSettings.vue?vue&type=script&lang=js"
export * from "./TransactionSettings.vue?vue&type=script&lang=js"
import style0 from "./TransactionSettings.vue?vue&type=style&index=0&id=85f9e810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f9e810",
  null
  
)

export default component.exports